export const TRANSLATIONS = {
   en:{
       Resources:{
         THANK_YOU: 'Thank you!',
       },
   },
   hi:{
        Resources:{
          THANK_YOU: 'धन्यवाद!',
        },
    },
};
